import LegalPage, { Section } from "@/components/LegalPage";

export default function BillingTerms() {
  return (
    <LegalPage
      title="Subscription & Billing Terms"
      metaTitle="AleaEdge Subscription & Billing Terms"
      metaDescription="How AleaEdge subscriptions and one-time parlay purchases are billed — recurring billing, cancellation, failed payments, taxes, and Stripe portal access."
      canonical="/billing-terms"
      intro="These billing terms apply to all paid AleaEdge plans and one-time purchases. They sit alongside our Terms of Service and Refund Policy."
    >
      <Section title="1. Plans">
        <p>AleaEdge offers a monthly Pro subscription that unlocks the full Top 5, all picks, and premium analysis. We also offer one-time parlay purchases that grant immediate access to a specific parlay drop. Free accounts may access a limited daily preview.</p>
      </Section>

      <Section title="2. Recurring Billing">
        <p>Pro subscriptions are billed in advance on a recurring monthly cycle starting on the day you subscribe. Your payment method is automatically charged each cycle until you cancel. The current price and renewal date are always visible in your account.</p>
      </Section>

      <Section title="3. Payment Processing">
        <p>All payments are processed by <span className="text-foreground font-medium">Stripe</span>. AleaEdge does not store full card numbers. Stripe is a PCI-DSS Level 1 certified payment processor and operates under its own terms and privacy policy.</p>
      </Section>

      <Section title="4. Managing Your Subscription">
        <p>You can update your card, view invoices, change plans, or cancel at any time from your account page, which opens a secure Stripe customer portal. Cancellation takes effect at the end of the current billing period — you keep access until then.</p>
      </Section>

      <Section title="5. Failed Payments">
        <p>If a payment fails, Stripe will retry the charge over several days. During this time your access may be limited. If the charge does not succeed after retries, your subscription will be paused or cancelled. You can restore access at any time by updating your payment method.</p>
      </Section>

      <Section title="6. One-Time Parlay Purchases">
        <p>Parlay drops are sold as one-time digital purchases. Once payment is completed, the parlay is unlocked immediately and is yours to view for the duration of its relevance. Parlay purchases do not auto-renew and do not extend or modify any subscription.</p>
      </Section>

      <Section title="7. Pricing Changes">
        <p>We may change subscription pricing from time to time. Existing subscribers will be notified by email at least 14 days before any price increase takes effect on their next renewal, and may cancel before the change applies.</p>
      </Section>

      <Section title="8. Taxes and Fees">
        <p>Prices shown do not include sales tax, VAT, or other taxes that may apply based on your billing location. Where required by law, applicable taxes are calculated and collected at checkout by Stripe.</p>
      </Section>

      <Section title="9. Account Downgrades">
        <p>If you cancel or your subscription lapses, your account is downgraded to the free tier at the end of the paid period. Your account, history, and settings are preserved — you can resubscribe at any time to restore full access.</p>
      </Section>

      <Section title="10. Refunds">
        <p>Refund eligibility is described in the <a href="/refund-policy" className="text-primary hover:underline">Refund Policy</a>.</p>
      </Section>

      <Section title="11. Contact">
        <p>Billing questions: <a href="mailto:support@aleaedge.com" className="text-primary hover:underline">support@aleaedge.com</a>.</p>
      </Section>
    </LegalPage>
  );
}
